export default __webpack_public_path__ + "static/media/bottomRight.bbd8d568.svg";